import { ClusterDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClusterService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCluster(): Observable<ClusterDto[]> {
    return this.http.get<ClusterDto[]>(this.url + 'cluster');
  }

  createCluster(data: ClusterDto[]): Observable<ClusterDto[]> {
    return this.http.post<ClusterDto[]>(this.url + 'cluster', data);
  }
  getSingleCluster(id: string): Observable<any> {
    return this.http.get(this.url + 'cluster/' + id);
  }

  updateCluster(data: ClusterDto[]): Observable<ClusterDto[]> {
    return this.http.post<ClusterDto[]>(this.url + 'cluster/update', data);
  }

  deleteCluster(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('cluster', ids.join(', '));
    return this.http.delete(this.url + 'cluster', httpOptions);
  }
}
